// ** Routes Imports
import DashboardRoutes from "./Dashboard"
import ManagementRoutes from "./Management"
import CategoryRoutes from "./Category"
import SystemRoutes from "./System"
import ReportRoutes from "./Report"
import Other from "./Other"
import ConfigurationRoutes from "./Configuration"
import ApplicationRoutes from "./Application"
import HistoryRoutes from "./History"

// ** Document title
const TemplateTitle = "%s - CyberID Administration"

// ** Default Route
const DefaultRoute = "/dashboard/person"

// ** Merge Routes
const Routes = [
  ...DashboardRoutes,
  ...ManagementRoutes,
  ...CategoryRoutes,
  ...SystemRoutes,
  ...ReportRoutes,
  ...Other,
  ...ConfigurationRoutes,
  ...ApplicationRoutes,
  ...HistoryRoutes
]

export { DefaultRoute, TemplateTitle, Routes }
